/* DndEditor — settings sub-section.
 *
 * Inside the SettingsPanel section grid (16px horizontal inset).
 * Two blocks: a description paragraph and the Snooze 1h banner.
 */

.container {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-12);
  padding-bottom: var(--spacing-12);
}

/* Snooze banner — high-prominence area. When inactive, shows a single
 * primary button. When active, shows the active-until indicator +
 * Cancel button. The banner sits inside the section rhythm so the
 * outer SectionHeader still reads at the top of the section.
 */
.snoozeBanner {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-8);
  padding: var(--spacing-12) var(--spacing-16);
  background: var(--bg-secondary);
  margin: 0 var(--spacing-16);
  border-radius: var(--radius-12, 12px);
}

.snoozeActiveRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-8);
}

.snoozeActiveText {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

/* Description text uses the same horizontal inset as the snooze
 * banner so the two blocks line up. */
.description {
  padding: 0 var(--spacing-16);
}
